var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScanDelete = function SvgScanDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "scan_delete_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#scan_delete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V4q0-.824.588-1.412A1.93 1.93 0 0 1 6 2h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85q.275.275.425.638.15.361.15.762v3.525a5.6 5.6 0 0 0-.975-.262A6 6 0 0 0 18 12V9h-3q-.825 0-1.412-.588A1.93 1.93 0 0 1 13 7V4H6v16h6.35q.2.575.5 1.075t.7.925zm12-2.575L16.6 20.8a.98.98 0 0 1-.688.287.93.93 0 0 1-.712-.287.95.95 0 0 1-.275-.7q0-.425.275-.7l1.4-1.4-1.4-1.4a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l1.4 1.4 1.4-1.4a.98.98 0 0 1 .688-.287.93.93 0 0 1 .712.287.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L19.425 18l1.375 1.4q.276.275.287.688a.93.93 0 0 1-.287.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275z"
  }))));
};
export default SvgScanDelete;